"use client";

import { FormEvent, useState } from "react";

type ContactOrmaeModalButtonProps = {
    buttonClassName?: string;
    buttonLabel?: string;
    showArrow?: boolean;
};

export function ContactOrmaeModalButton({
    buttonClassName,
    buttonLabel = "Contact Ormae Team",
    showArrow = true,
}: ContactOrmaeModalButtonProps) {
    const [isOpen, setIsOpen] = useState(false);
    const [name, setName] = useState("");
    const [email, setEmail] = useState("");
    const [organization, setOrganization] = useState("");
    const [comment, setComment] = useState("");

    const defaultButtonClassName = "inline-flex items-center gap-2 rounded-full bg-lime-500 px-6 py-2.5 text-[13px] font-semibold text-white transition hover:bg-lime-400";

    function closeModal() {
        setIsOpen(false);
    }

    function onSubmit(event: FormEvent<HTMLFormElement>) {
        event.preventDefault();
        closeModal();
        setName("");
        setEmail("");
        setOrganization("");
        setComment("");
    }

    return (
        <>
            <button
                type="button"
                onClick={() => setIsOpen(true)}
                className={buttonClassName ?? defaultButtonClassName}
            >
                {buttonLabel}
                {showArrow && <span aria-hidden>→</span>}
            </button>

            {isOpen && (
                <div
                    className="fixed inset-0 z-50 flex items-center justify-center bg-black/45 px-4"
                    onClick={closeModal}
                >
                    <div
                        className="w-full max-w-xl rounded-3xl bg-white p-6 text-left shadow-2xl"
                        onClick={(event) => event.stopPropagation()}
                    >
                        <div className="mb-4 flex items-start justify-between gap-3">
                            <h2 className="text-2xl font-semibold text-emerald-950">Contact Ormae Team</h2>
                            <button
                                type="button"
                                onClick={closeModal}
                                className="rounded-full p-2 text-zinc-500 hover:bg-zinc-100"
                                aria-label="Close contact form"
                            >
                                ✕
                            </button>
                        </div>

                        <form onSubmit={onSubmit} className="space-y-4">
                            <label className="block">
                                <span className="text-xs font-semibold tracking-[0.14em] text-emerald-700 uppercase">Name</span>
                                <input
                                    required
                                    value={name}
                                    onChange={(event) => setName(event.target.value)}
                                    className="mt-1.5 w-full rounded-xl border border-zinc-300 px-4 py-2.5 text-sm text-zinc-700 outline-none ring-emerald-400 focus:ring"
                                    placeholder="Your name"
                                />
                            </label>

                            <label className="block">
                                <span className="text-xs font-semibold tracking-[0.14em] text-emerald-700 uppercase">Email</span>
                                <input
                                    required
                                    type="email"
                                    value={email}
                                    onChange={(event) => setEmail(event.target.value)}
                                    className="mt-1.5 w-full rounded-xl border border-zinc-300 px-4 py-2.5 text-sm text-zinc-700 outline-none ring-emerald-400 focus:ring"
                                    placeholder="you@company.com"
                                />
                            </label>

                            <label className="block">
                                <span className="text-xs font-semibold tracking-[0.14em] text-emerald-700 uppercase">Organisation</span>
                                <input
                                    required
                                    value={organization}
                                    onChange={(event) => setOrganization(event.target.value)}
                                    className="mt-1.5 w-full rounded-xl border border-zinc-300 px-4 py-2.5 text-sm text-zinc-700 outline-none ring-emerald-400 focus:ring"
                                    placeholder="Company name"
                                />
                            </label>

                            <label className="block">
                                <span className="text-xs font-semibold tracking-[0.14em] text-emerald-700 uppercase">Comment</span>
                                <textarea
                                    value={comment}
                                    onChange={(event) => setComment(event.target.value)}
                                    rows={4}
                                    className="mt-1.5 w-full rounded-xl border border-zinc-300 px-4 py-2.5 text-sm text-zinc-700 outline-none ring-emerald-400 focus:ring"
                                    placeholder="Tell us about your requirements"
                                />
                            </label>

                            <div className="flex justify-end gap-3 pt-1">
                                <button
                                    type="button"
                                    onClick={closeModal}
                                    className="rounded-full border border-zinc-300 px-4 py-2 text-sm font-semibold text-zinc-600"
                                >
                                    Cancel
                                </button>
                                <button
                                    type="submit"
                                    className="rounded-full bg-gradient-to-r from-emerald-900 to-emerald-500 px-5 py-2 text-sm font-semibold text-white"
                                >
                                    Submit
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            )}
        </>
    );
}
